
import { useState, useRef, RefObject } from "react";
import useUtils from '../../../../utiles/useUtiles';
import { Field, Form, Formik, FormikHelpers } from 'formik';
import * as Yup from "yup";
import FormErrorContainer from '../../../sections/shared/FormErrorContainer';
import { CircularProgress } from '@mui/material';


interface Props {
    setStep: ( n: number ) => void, 
    setCsvUUID: ( uuid: string | null) => void
}
const CsvUpload: React.FC<Props> = ( { setStep, setCsvUUID } ): JSX.Element => {

    // const [file, setFile] = useState();
    const [loading, setLoading] = useState( false );
    const fileRef = useRef<HTMLInputElement>(null);
    const { axiosRequest, baseUrl, toastInstance } = useUtils()
    const axios = axiosRequest();
    const toast = toastInstance();

    const TemplateStep1FormValidation = Yup.object().shape( {
        file: Yup.mixed()
        .required( 'File is required' )
        .test( 'is-valid-size', 'File size exceeded', value => {
            let valid = true;
            const file = fileRef && fileRef?.current && fileRef?.current?.files && fileRef?.current?.files[0];
            if ( file ) {
                const maxSize = 15 * 1024 * 1024; // 15 MB
                if ( file.size > maxSize ) {
                    valid = false;
                }
            }
            return valid;
        } )
        .test(
            "is-file-of-correct-type",
            "File is not of supported type",
            () => {
              let valid = true;
              const file = fileRef?.current?.files && fileRef?.current?.files[0];
              if ( file ) {
                const type = file.type.split( "/" )[1];
                const validTypes = [ "csv" ];
                if ( !validTypes.includes( type ) ) {
                    valid = false;
                }
              }
              return valid;
            }
        )
    } );

    const onFileUpload = async ( file: File ) => {
        const formData = new FormData();
        formData.append(
            "file",
            file
        );

        setLoading( true );
        const request = await axios.post( `${baseUrl()}/template/upload/csv`, formData );
        const { error, result, message } = request.data;
        setLoading( false );
        if ( error ) {
            toast.error( message );
        } else {
            toast.success( message );
            setCsvUUID( result );
            setStep( 2 );
        }
 
        // Request made to the backend api
        // Send formData object
        // axios.post("api/uploadfile", formData);
    };

    return (
        <div className="main-card">
            <Formik
                initialValues={{
                    file: ''
                }}
                validateOnChange={true}
                validateOnBlur={true}
                validationSchema={TemplateStep1FormValidation}
                onSubmit={async ( values, helpers ) => {
                    if ( fileRef.current && fileRef.current.files && fileRef.current.files.length ) {
                        onFileUpload( fileRef.current.files[0] );
                    } else {
                        toast.error( 'Please select any csv file' );
                    }
                }}>
                {( form ) => (
                    <Form>
                        <h1 className="text-center mb-5">Upload CSV</h1>
                        <div className="mb-4">
                            <div className="file-input">
                                {/* <Field name="file" type="file" accept=".csv" className="form-control" placeholder="Upload file" ref={fileRef} /> */}
                                <input data-cy="inputFileCSV" type={"file"} accept=".csv" placeholder="Upload file" ref={fileRef} { ...form.getFieldProps( 'file' ) } />
                                <span className="button">Browse</span>
                                <span className="label" data-js-label="">
                                    {form.values.file ? form.values.file:"No file selected"}
                                </span>
                            </div>
                            <FormErrorContainer nameError={form.errors.file}  />
                        </div>
                        <div>
                            <button data-cy="btnSubmit" type="submit" className="btn btn-md revrex-primary-btn mt-3" disabled={loading}>
                                <span>{ loading && ( <CircularProgress size={20} color={'success'} /> ) || 'Upload' }</span>
                            </button>
                            {/* <a className="revrex-primary-btn" onClick={() => onFileUpload()} disabled={loading}>
                                { loading && (<CircularProgress size={20} color={'success'} />) || 'Upload' }
                            </a> */}
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );

}

export default CsvUpload;